/**
 * OrderCommentsUpdateRequest class to update internal comments and 
 * support category of an order. Also it is used to update comments
 * for each order item
 * @author Vinay Bhopani
 */
export class OrderCommentsUpdateRequest {
    orderId: string;
    internalComment: string;
    supportCategory: string;
}